import { render, staticRenderFns } from "./promoted-object-input.vue?vue&type=template&id=2f17d34a&scoped=true"
import script from "./promoted-object-input.vue?vue&type=script&lang=js"
export * from "./promoted-object-input.vue?vue&type=script&lang=js"
import style0 from "./promoted-object-input.vue?vue&type=style&index=0&id=2f17d34a&prod&lang=scss&scoped=true"
import style1 from "./promoted-object-input.vue?vue&type=style&index=1&id=2f17d34a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f17d34a",
  null
  
)

export default component.exports